/** vendor */
import React, { useState, useEffect } from 'react'
import { TrashIcon, PencilAltIcon } from '@heroicons/react/solid'
import { IMG_URL, PLACEHOLDER_IMG } from '../../../constants/ApiConfiguration'

/** components */
import CreateStepDialog from '../../Dialogs/CreateStepDialog'

export default function CreateStepsForm({onUpdate, recipe}) {
    const [showDialog, setShowDialog] = useState(false)
    const [editStep, setEditStep] = useState(undefined);
    const [steps, setSteps] = useState(recipe?.steps || []);

    /**
     * Handlers
     */
    const handleOnUpdate = step => {
        const stepIndex = steps?.findIndex(s => s?.id === step?.id)

        if (stepIndex > -1) {
            const stepsCopy = [...steps]
            stepsCopy[stepIndex] = step
            setSteps(stepsCopy)
        } else {
            setSteps([...steps, step])
            onUpdate({steps: [...steps, step]})
        }

        setShowDialog(false)
    }

    const handleRemoveStep = index => {
        const stepsCopy = [...steps]
       
        stepsCopy.splice(index, 1)
        setSteps(stepsCopy)
        onUpdate({steps})
    }

    const handleEditStep = (step) => {
        setEditStep(step)
        setShowDialog(true)
    }

    const handleOnCancel =  e => {
        setEditStep(undefined)
        setShowDialog(false)
    }

    return (
        <div className="pb-14 w-full px-2">
            <ul role="list" className="flex-grow min-w-full overflow-y-scroll">
                {
                    steps?.map((step, index) => {
                        return (
                            <li className="min-w-full odd:bg-an_white-dark px-2" key={index}>
                                <div className="flex items-start space-x-4">
                                    <div className="flex-shrink-0 py-2 pl-0">
                                        <img className="w-8 h-8 rounded-lg border-an_green-dark border overflow-hidden" src={step?.image ?? PLACEHOLDER_IMG} alt="ingredient image" />
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <p className="text-base text-an_green-dark h-8 leading-8 py-2">
                                            {step.title}
                                        </p>

                                        {
                                            step?.description &&
                                                <small className="text-xs text-an_green-dark block pt-4 pb-2 leading-none">
                                                    {step?.description}
                                                </small>
                                        }
                                    </div>
                                    <div className="flex flex-col items-center py-2">
                                        <div className="inline-flex items-center justify-center text-base font-semibold text-an_green-dark">
                                            <PencilAltIcon className="h-4 w-4 text-an_green cursor-pointer mr-1" onClick={() => { handleEditStep(step) }} />
                                            <TrashIcon className="h-4 w-4 text-an_orange-dark cursor-pointer" onClick={() => { handleRemoveStep(index) }} />
                                        </div>
                                        <small className="text-xs mt-1">{step?.timer}</small>
                                    </div>
                                    
                                </div>
                            </li>
                        )
                    })
                }
            </ul>

            <div 
                className="border rounded-b-sm border-an_green-dark py-2 bg-an_white-dark  absolute bottom-0 left-2"
                style={{ width: 'calc(100% - 1rem)' }}
            >
                <button 
                    className={`block mx-auto px-5 py-2 rounded p-2 w-56 border border-an_orange-darker3 text-an_white bg-an_orange text-border-orange`}
                    onClick={() => { setShowDialog(true) }}

                >
                    create step
                </button>
            </div>

            <CreateStepDialog 
                showDialog={showDialog} 
                onCancel={handleOnCancel} 
                onUpdate={handleOnUpdate} 
                step={editStep}
            />
        </div>
    )
}

